import { settingsService } from '../services/settingsService';
import { isMobileAudioEnvironment } from './mobileAudioEnvironment';

export const UPLINK_MIC_GAIN_MIN = 0.1;
export const UPLINK_MIC_GAIN_MAX = 8;
export const UPLINK_MIC_GAIN_DEFAULT_MOBILE = 1.45;
export const UPLINK_MIC_GAIN_DEFAULT_DESKTOP = 1;

export function clampUplinkMicGain(value: number): number {
  if (!Number.isFinite(value)) {
    return UPLINK_MIC_GAIN_DEFAULT_DESKTOP;
  }
  return Math.min(Math.max(value, UPLINK_MIC_GAIN_MIN), UPLINK_MIC_GAIN_MAX);
}

export function getDefaultUplinkMicGain(): number {
  return isMobileAudioEnvironment()
    ? UPLINK_MIC_GAIN_DEFAULT_MOBILE
    : UPLINK_MIC_GAIN_DEFAULT_DESKTOP;
}

/** 用户设置优先；未设置时使用平台默认值 */
export function getUplinkMicGain(): number {
  const stored = settingsService.getAudioSettings().uplinkMicGain;
  if (typeof stored === 'number' && Number.isFinite(stored)) {
    return clampUplinkMicGain(stored);
  }
  return getDefaultUplinkMicGain();
}

export function hasStoredUplinkMicGain(): boolean {
  const stored = settingsService.getAudioSettings().uplinkMicGain;
  return typeof stored === 'number' && Number.isFinite(stored);
}
